import React, { useMemo } from 'react';
import { Anchor, Box, Hint, Text } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { Access } from '@/modules/core/components';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { EmployerStatus } from '@/modules/employer/employer.constants';

import { useEditModeStore, usePreviewStore } from '../../stores';

interface Props {
  isTemplateMode?: boolean;
  isPlanTerminated?: boolean;
}
const SwitchToEditMode: React.FC<Props> = ({ isTemplateMode, isPlanTerminated }) => {
  const previewMode = usePreviewStore((state) => state.previewMode);
  const setEditMode = useEditModeStore((state) => state.setEditMode);

  const { observingOrganization } = useCurrentOrganization();
  const isTerminationStatus = useMemo(() => observingOrganization.status === EmployerStatus.PendingTermination
  || observingOrganization.status === EmployerStatus.TerminationInProgress
  || observingOrganization.status === EmployerStatus.Terminated, [observingOrganization]);

  if (previewMode) {
    return null;
  }

  return (
    <Access
      accessRequirements={[
        {
          permission: isTemplateMode
            ? Permissions.PLAN_TEMPLATE_SETUP
            : Permissions.EDIT_DRAFT_PLAN,
        },
      ]}
    >
      <Box direction="column" align="center" margin={{ top: 'spacing24', bottom: 'spacing8' }}>
        <Text size="medium" color="textSecondary">
          To apply any changes, please switch to {' '}
          <Hint
            hideHint={(!isTerminationStatus && !isPlanTerminated) || isTemplateMode}
            hintAlign="left"
            style={{ display: 'inline-flex' }}
            hintElement={(
              <Anchor
                onClick={() => setEditMode(true)}
                weight="normal"
                label="Edit Mode"
                disabled={isTerminationStatus || isPlanTerminated && !isTemplateMode}
              />
            )}
          >
            <Text size="small" color="textOnColor" textAlign="center">
              {isPlanTerminated ? 'Terminated plans cannot be edited.' : 'Terminated organizations cannot edit plan.'}
            </Text>
          </Hint>
          .
        </Text>
      </Box>
    </Access>
  );
};

export default SwitchToEditMode;
